// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/UST.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/ust-logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
 
}

.login-page__backdrop {
  position: fixed;
  inset: 0;
  pointer-events: none;
  background-image: radial-gradient(circle at 20% 20%, rgba(22, 119, 255, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 80% 80%, rgba(9, 88, 217, 0.2) 0%, transparent 50%);
}

.login-page__shell {
  position: relative;
  z-index: 1;
  width: 100%;
  
}

.login-page__hero {
  margin-bottom: 20px;
  text-align: center;
}

.login-page__logo {
  width: 48px;
  height: 48px;
  margin-bottom: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: linear-gradient(135deg, #1677ff, #0958d9);
  box-shadow: 0 8px 32px rgba(22, 119, 255, 0.4);
}

.login-page__title {
  margin: 0;
  color: #ffffff!important;
  font-size: 28px!important;
  font-weight: 700!important;
      margin-bottom: 3px!important;
}
.login-page__subtitle {
  display: block;
  margin-top: 2px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  font-weight: 600;
}

.login-page__features {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  flex-wrap: nowrap;
  overflow-x: auto;
}

.login-page__feature {
    display: flex;
    align-items: center;
    gap: 3px;
    min-width: 92px;
    padding: 0 0px 0px 4px;
    text-align: left;
    font-weight: 700;
}

.login-page__feature-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #106aee;
  font-size: 22px;
}

.login-page__feature-label {
    max-width: 67px;
    color: rgba(255, 255, 255, 0.85);
    font-size: 11px;
    font-weight: 600;
    line-height: 1.3;
    white-space: normal;
}

.login-page__feature-divider {
  color: #1e5bb5;
  font-size: 22px;
  font-weight: 300;
}

.login-card {


  margin-bottom: 16px;
  border-radius: 16px;
  padding: 28px 28px 24px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.35);
}

.login-card__heading {
    margin-top: 10px;
    margin-bottom: 2px!important;
    font-weight: 700!important;
    color: #1677ff !important;
    text-align: center;
}

.login-card__subheading {
  display: block;
  height: 40px;
  margin-bottom: 20px;
  color: #595959;
  font-size: 13px;
  text-align: center;
}

.login-card__alert {
  margin-bottom: 16px;
}

.login-form-item {
  margin-bottom: 14px;
}

.login-form-label {
  color: #262626;
  font-size: 13px;
  font-weight: 650;
}

.login-input {
  height: 40px;
  border-radius: 8px;
  font-size: 13px;
}

.login-input__icon {
  color: #bfbfbf;
}

.login-options {
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.login-checkbox {
  font-size: 13px;
}

.login-link-button,
.login-support-button {
  padding: 0;
  height: auto;
  font-size: 13px;
  color: #1677ff;
}

.login-submit-button {
  height: 40px;
  border-radius: 8px;
  background: #1677ff;
  font-size: 14px;
  font-weight: 600;
}

.login-submit-icon {
  margin-left: 6px;
}

.login-register {
  margin-top: 20px;
  padding-top: 16px;
  text-align: center;
  border-top: 1px solid #f0f0f0;
}

.login-register__text {
  color: #595959;
  font-size: 13px;
}

.login-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
  color: rgba(255, 255, 255, 0.6);
  font-size: 11px;
}

.login-footer__text,
.login-footer__support {
  color: rgba(255, 255, 255, 0.6);
  font-size: 11px;
}

.login-footer__support {
  color: rgba(255, 255, 255, 0.7);
}

.login-footer__icon {
  margin-right: 4px;
}

.login-copy {
  display: block;
  margin-top: 12px;
  text-align: center;
  color: rgba(255, 255, 255, 0.4);
  font-size: 11px;
}

.login-modal__title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.login-modal__title-text {
  color: #1677ff;
  font-weight: 700;
}

.login-modal__footer {
  display: flex;
  gap: 8px;
}

.login-modal__button,
.login-modal__button--primary {
  border-radius: 8px;
}

.login-modal__button--primary {
  font-weight: 600;
}

.login-forgot-success {
  padding: 16px 0;
  text-align: center;
}

.login-forgot-success__icon {
  margin-bottom: 12px;
  font-size: 48px;
}

.login-forgot-success__title {
  margin-bottom: 8px;
  color: #52c41a;
}

.login-forgot-success__text,
.login-forgot-copy,
.login-forgot-label {
  color: #595959;
  font-size: 13px;
}

.login-forgot-copy {
  display: block;
  margin-top: 4px;
  margin-bottom: 20px;
}

.login-forgot-label {
  font-weight: 600;
}

.login-container {
  display: flex;
  height: 100vh;
  flex-direction: column;
  justify-content: space-between;
  max-width: 100%;
  padding: 0;
}

@media (min-width: 1024px) {
  .login-container {
    flex-direction: row;
  }
}

.left-section {
  flex: 1;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/cover no-repeat;
  display: none; /* Hide on mobile */
  margin-bottom: 55px;
}

@media (min-width: 1024px) {
  .left-section {
    display: block; /* Show on large screens */
  }
}

.right-section {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(247, 244, 244);
  width: 100%;
  padding: 20px;
}

@media (max-width: 768px) {
  .right-section {
    padding: 10px;
  }
}
.login-title{
  color: #014D4E;
}
.login-card {
  width: 100%;
  max-width: 400px;
  padding: 20px;
  background: rgb(255, 255, 255);
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.logo-container {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}

.ust-logo {
  width: 80px;
  height: auto;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/cover no-repeat;
}

.login-image {
  height: 78px;
  width: 105px;
}

/* ✅ Updated Button Color */
.custom-button {
  background-color: #1f415b !important;
  border: none;
}

.custom-button:hover {
  background-color: #1677ff !important;
}

/* ✅ Forgot Password Link Color */
.forgot-password {
  color: #1f415b !important;
  text-decoration: none;
}

.forgot-password:hover {
  text-decoration: underline;
}

/* ✅ Custom Checkbox Color */
.custom-checkbox .ant-checkbox-inner {
  border-color: #1f415b !important;
}

.custom-checkbox .ant-checkbox-checked .ant-checkbox-inner {
  background-color: #1f415b !important;
  border-color: #1f415b !important;
}
`, "",{"version":3,"sources":["webpack://./src/gitsubmodules/trackon/src/components/Login/Login.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;;AAEf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB;iFAC+E;AACjF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;;AAEb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;MACtB,4BAA4B;AAClC;AACA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,MAAM;EACN,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;EACE,cAAc;EACd,YAAY;EAEZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;;EAEE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;EAGE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,OAAO;EACP,0EAA6D;EAC7D,aAAa,EAAE,mBAAmB;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc,EAAE,0BAA0B;EAC5C;AACF;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0EAAkE;AACpE;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC","sourcesContent":[".login-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n \n}\n\n.login-page__backdrop {\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n  background-image: radial-gradient(circle at 20% 20%, rgba(22, 119, 255, 0.15) 0%, transparent 50%),\n    radial-gradient(circle at 80% 80%, rgba(9, 88, 217, 0.2) 0%, transparent 50%);\n}\n\n.login-page__shell {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  \n}\n\n.login-page__hero {\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.login-page__logo {\n  width: 48px;\n  height: 48px;\n  margin-bottom: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #1677ff, #0958d9);\n  box-shadow: 0 8px 32px rgba(22, 119, 255, 0.4);\n}\n\n.login-page__title {\n  margin: 0;\n  color: #ffffff!important;\n  font-size: 28px!important;\n  font-weight: 700!important;\n      margin-bottom: 3px!important;\n}\n.login-page__subtitle {\n  display: block;\n  margin-top: 2px;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.login-page__features {\n  margin-top: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n}\n\n.login-page__feature {\n    display: flex;\n    align-items: center;\n    gap: 3px;\n    min-width: 92px;\n    padding: 0 0px 0px 4px;\n    text-align: left;\n    font-weight: 700;\n}\n\n.login-page__feature-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #106aee;\n  font-size: 22px;\n}\n\n.login-page__feature-label {\n    max-width: 67px;\n    color: rgba(255, 255, 255, 0.85);\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 1.3;\n    white-space: normal;\n}\n\n.login-page__feature-divider {\n  color: #1e5bb5;\n  font-size: 22px;\n  font-weight: 300;\n}\n\n.login-card {\n\n\n  margin-bottom: 16px;\n  border-radius: 16px;\n  padding: 28px 28px 24px;\n  background: rgba(255, 255, 255, 0.98);\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.35);\n}\n\n.login-card__heading {\n    margin-top: 10px;\n    margin-bottom: 2px!important;\n    font-weight: 700!important;\n    color: #1677ff !important;\n    text-align: center;\n}\n\n.login-card__subheading {\n  display: block;\n  height: 40px;\n  margin-bottom: 2px!important;\n  margin-bottom: 20px;\n  color: #595959;\n  font-size: 13px;\n  text-align: center;\n}\n\n.login-card__alert {\n  margin-bottom: 16px;\n}\n\n.login-form-item {\n  margin-bottom: 14px;\n}\n\n.login-form-label {\n  color: #262626;\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.login-input {\n  height: 40px;\n  border-radius: 8px;\n  font-size: 13px;\n}\n\n.login-input__icon {\n  color: #bfbfbf;\n}\n\n.login-options {\n  margin-bottom: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.login-checkbox {\n  font-size: 13px;\n}\n\n.login-link-button,\n.login-support-button {\n  padding: 0;\n  height: auto;\n  font-size: 13px;\n  color: #1677ff;\n}\n\n.login-submit-button {\n  height: 40px;\n  border-radius: 8px;\n  background: #1677ff;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.login-submit-icon {\n  margin-left: 6px;\n}\n\n.login-register {\n  margin-top: 20px;\n  padding-top: 16px;\n  text-align: center;\n  border-top: 1px solid #f0f0f0;\n}\n\n.login-register__text {\n  color: #595959;\n  font-size: 13px;\n}\n\n.login-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  flex-wrap: wrap;\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 11px;\n}\n\n.login-footer__text,\n.login-footer__support {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 11px;\n}\n\n.login-footer__support {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.login-footer__icon {\n  margin-right: 4px;\n}\n\n.login-copy {\n  display: block;\n  margin-top: 12px;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.4);\n  font-size: 11px;\n}\n\n.login-modal__title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.login-modal__title-text {\n  color: #1677ff;\n  font-weight: 700;\n}\n\n.login-modal__footer {\n  display: flex;\n  gap: 8px;\n}\n\n.login-modal__button,\n.login-modal__button--primary {\n  border-radius: 8px;\n}\n\n.login-modal__button--primary {\n  font-weight: 600;\n}\n\n.login-forgot-success {\n  padding: 16px 0;\n  text-align: center;\n}\n\n.login-forgot-success__icon {\n  margin-bottom: 12px;\n  font-size: 48px;\n}\n\n.login-forgot-success__title {\n  margin-bottom: 8px;\n  color: #52c41a;\n}\n\n.login-forgot-success__text,\n.login-forgot-copy,\n.login-forgot-label {\n  color: #595959;\n  font-size: 13px;\n}\n\n.login-forgot-copy {\n  display: block;\n  margin-top: 4px;\n  margin-bottom: 20px;\n}\n\n.login-forgot-label {\n  font-weight: 600;\n}\n\n.login-container {\n  display: flex;\n  height: 100vh;\n  flex-direction: column;\n  justify-content: space-between;\n  max-width: 100%;\n  padding: 0;\n}\n\n@media (min-width: 1024px) {\n  .login-container {\n    flex-direction: row;\n  }\n}\n\n.left-section {\n  flex: 1;\n  background: url(\"/src/assets/UST.jpg\") center/cover no-repeat;\n  display: none; /* Hide on mobile */\n  margin-bottom: 55px;\n}\n\n@media (min-width: 1024px) {\n  .left-section {\n    display: block; /* Show on large screens */\n  }\n}\n\n.right-section {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: rgb(247, 244, 244);\n  width: 100%;\n  padding: 20px;\n}\n\n@media (max-width: 768px) {\n  .right-section {\n    padding: 10px;\n  }\n}\n.login-title{\n  color: #014D4E;\n}\n.login-card {\n  width: 100%;\n  max-width: 400px;\n  padding: 20px;\n  background: rgb(255, 255, 255);\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.logo-container {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 8px;\n}\n\n.ust-logo {\n  width: 80px;\n  height: auto;\n  background: url(\"/src/assets/ust-logo.png\") center/cover no-repeat;\n}\n\n.login-image {\n  height: 78px;\n  width: 105px;\n}\n\n/* ✅ Updated Button Color */\n.custom-button {\n  background-color: #1f415b !important;\n  border: none;\n}\n\n.custom-button:hover {\n  background-color: #1677ff !important;\n}\n\n/* ✅ Forgot Password Link Color */\n.forgot-password {\n  color: #1f415b !important;\n  text-decoration: none;\n}\n\n.forgot-password:hover {\n  text-decoration: underline;\n}\n\n/* ✅ Custom Checkbox Color */\n.custom-checkbox .ant-checkbox-inner {\n  border-color: #1f415b !important;\n}\n\n.custom-checkbox .ant-checkbox-checked .ant-checkbox-inner {\n  background-color: #1f415b !important;\n  border-color: #1f415b !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
